import { DownloadPDF } from '@/_containers';

import { useGetAgreementPdfMutation } from '../apis';

export function DownloadAgreementPDF({ id }: { id: string }) {
  const { mutateAsync } = useGetAgreementPdfMutation(id);

  return <DownloadPDF printMode={false} mutateFunction={mutateAsync} />;
}
